import { useQuery } from '@tanstack/react-query';
import { fetchTestimonials, Testimonial } from '../services/testimonialService';

export const testimonialKeys = {
  all: ['testimonials'] as const,
};

export const useTestimonials = () => {
  return useQuery<Testimonial[]>({
    queryKey: testimonialKeys.all,
    queryFn: fetchTestimonials,
    staleTime: 5 * 60 * 1000, // 5 minutes
    gcTime: 10 * 60 * 1000, // 10 minutes
  });
};
